import { render, staticRenderFns } from "./FeedbackComments.vue?vue&type=template&id=0b17ec49"
import script from "./FeedbackComments.vue?vue&type=script&lang=js"
export * from "./FeedbackComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b17ec49')) {
      api.createRecord('0b17ec49', component.options)
    } else {
      api.reload('0b17ec49', component.options)
    }
    module.hot.accept("./FeedbackComments.vue?vue&type=template&id=0b17ec49", function () {
      api.rerender('0b17ec49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FeedbackComments.vue"
export default component.exports